import { Component, Input } from '@angular/core';
import { FormDataComment } from 'src/app/models/comment';

@Component({
  selector: 'app-comments-view',
  templateUrl: './comments-view.component.html',
  styleUrls: ['./comments-view.component.scss']
})
export class CommentsViewComponent {
  @Input() comments: FormDataComment[];
  @Input() link = false;
  @Input() paragraphClass = '';

  constructor() { }

}
